import { createReducer } from "@reduxjs/toolkit";
import { IAssistanceAddressState } from "./types";
import * as actions from "./actions";
import { StoreState } from "../storeState";
import { STORAGE_RESET } from "../storeReset";

const initialState = {
  data: null,
  state: StoreState.None,
} as IAssistanceAddressState;

export const assistanceAddressReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(actions.assistanceAddressFetchRequest, (state) => ({
      ...state,
      state: StoreState.Loading,
    }))
    .addCase(actions.assistanceAddressFetchSuccess, (state, action) => ({
      ...state,
      state: StoreState.Loaded,
      data: action.payload,
    }))
    .addCase(actions.assistanceAddressFetchError, (state) => ({
      ...state,
      state: StoreState.Error,
    }))
    .addCase(STORAGE_RESET, () => initialState)
);
